import { IBaseNavRoute, INavRoute } from 'app/components';
import { IAppState, store } from 'app/redux/App/store'
import createBrowserHistory from 'history/createBrowserHistory'
import * as React from 'react'
import { Route } from 'react-router-dom'
import * as Redux from 'redux'

const history = createBrowserHistory()

/**
 * Container is a React component with access to the Application's State
 *
 * By default, a Container will automatically update it's state based
 * the abstract method: mapAppStateToContainerState()
 *
 */
abstract class Container<P, S> extends React.Component<P, S> {

  static History = history

  private unsubscribeFromStoreFN: Redux.Unsubscribe

  /**
   * Overrider's beware! Call super.componentWillMount()
   */
  componentWillMount() {
    this.subscribeContainerToStore()
  }

  /**
   * Overrider's beware! Call super.componentWillUnmount()
   */
  componentWillUnmount() {
    this.unsubscribeContainerFromStore()
  }

  /**
   * Invokes callback when the App's state has been updated
   * @param callback
   */
  subscribe(callback: (state: IAppState) => void) {
    const invokeCallback = () => {
      const currentState = this.getState()
      callback(currentState)
    }

    //Invoke callback with initial state
    invokeCallback()

    //Subscribe to future updates
    return store.subscribe(() => invokeCallback())
  }

  /**
   * Get state from App/Store
   */
  getState() {
    return store.getState()
  }

  /**
   * Get key/value search values from hash
   * Example /#/faq?id=asdf&thing=1 will return {id: 'asdf', thing: '1'}
   */
  getLocationSearch(): { [key: string]: string } {
    const search: { [key: string]: string } = {}
    const { hash } = location
    const questionIndex = hash.indexOf('?')

    if (questionIndex >= 0) {
      const searchStr = hash.substring(questionIndex + 1)
      const searchArr = searchStr.split('&')
      searchArr.forEach((elem) => {
        const items = elem.split('=')
        if (items.length >= 2) {
          const [key, value] = items
          search[key] = value
        }
      })
    }

    return search
  }

  /**
   * IBaseNavRoute to <Route /> Element
   * @param route
   * @param index
   */
  navRouteToReactRoute(route: IBaseNavRoute) {
    return (
      <Route key={route.path} exact path={route.path} component={route.component} />
    )
  }

  /**
   * AppNavRoutes to <Route /> Elements
   * @param navRoute
   * @param index
   */
  mapAppNavRoutesToReactRoutes(navRoute: INavRoute) {
    if (navRoute.single) {
      return this.navRouteToReactRoute(navRoute.single)
    }

    if (navRoute.multi) {
      return navRoute.multi.routes.map((route) => this.navRouteToReactRoute(route))
    }
  }

  /**
   * An abstract method that will map the App's state to the Container's state.
   * This method will be used to auto-sync the app and the container.
   *
   * @param appState
   */
  abstract mapAppStateToContainerState(appState: IAppState): S

  /**
   * Begin sync of App State and Container State
   */
  private subscribeContainerToStore() {
    this.unsubscribeFromStoreFN = this.subscribe((appState) => {
      const newContainerState = this.mapAppStateToContainerState(appState)

      this.setState(newContainerState)
    })
  }

  /**
   * End sync of App State and Container State
   */
  private unsubscribeContainerFromStore() {
    if (typeof this.unsubscribeFromStoreFN === 'function') {
      this.unsubscribeFromStoreFN()
    }
  }
}

export {
  Container,
  IAppState
}



// WEBPACK FOOTER //
// ./src/app/containers/Container.tsx